<section *ngIf="analytics.bannerOpen$ | async" class="cookie-consent" role="region" aria-label="Cookie consent">
  <p class="cookie-consent__text">Help us make 3DWay better? With your OK, Google Analytics cookies and our own analytics show us which pages people use and where they get stuck. No ads, and your files are never part of it. <a routerLink="/legal/cookies">Cookie Notice</a></p>
  <div class="cookie-consent__actions">
    <button class="cookie-consent__button" type="button" (click)="reject()">No thanks</button>
    <button class="cookie-consent__button" type="button" (click)="accept()">Accept</button>
  </div>
</section>
